module.exports = __webpack_public_path__ + "static/media/loader1.1808492a.gif";